import { useEffect, useState } from 'react';
import { readScreenOrientation } from '@/lib/screen-orientation';

const getOrientation = () => readScreenOrientation(typeof window === 'undefined' ? undefined : window);

const useScreenOrientation = () => {
    const [orientation, setOrientation] = useState(getOrientation);

    useEffect(() => {
        const handleOrientationChange = () => {
            setOrientation(getOrientation());
        }
        window.addEventListener('orientationchange', handleOrientationChange);
        window.addEventListener('resize', handleOrientationChange);
        window.screen?.orientation?.addEventListener?.('change', handleOrientationChange);
        return () => {
            window.removeEventListener('orientationchange', handleOrientationChange);
            window.removeEventListener('resize', handleOrientationChange);
            window.screen?.orientation?.removeEventListener?.('change', handleOrientationChange);
        }
    }, []);

    return orientation;
}

export default useScreenOrientation;

